import styled from 'styled-components';
import { Flexbox } from '@hiiretail/synergy-ui';

export const CertificatesBox = styled(Flexbox)`
  border-radius: 4px;
  border: 1px solid rgba(211, 211, 211, 0.48);
`;
